export default __webpack_public_path__ + "static/media/software-2.be84feae.png";